module.exports = __webpack_public_path__ + "static/media/checkout-page.2ff119ad.png";